export const DEFAULT_INITIAL_CHANNEL_PAGE_SIZE = 25;
export const DEFAULT_NEXT_CHANNEL_PAGE_SIZE = 100;
export const DEFAULT_JUMP_TO_PAGE_SIZE = 100;
export const DEFAULT_THREAD_PAGE_SIZE = 50;
export const DEFAULT_LOAD_PAGE_SCROLL_THRESHOLD = 250;
export const DEFAULT_UPLOAD_SIZE_LIMIT_BYTES = 100 * 1024 * 1024; // 100 MB
export const DEFAULT_HIGHLIGHT_DURATION = 500;
